import * as React from 'react';
import styled, {css} from 'styled-components';
import {transparentize} from 'polished';
import {HiddenAvatar} from 'icons';
import {ID} from 'types';

export interface StudentProps {
  id: ID;
  name: string;
  avatar: string;
  isHidden?: boolean;
}

const Wrapper = styled.div<Pick<StudentProps, 'isHidden'>>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 11px;
  border-radius: 5px;
  box-sizing: border-box;
  width: 140px;
  min-height: 140px;
  height: max-content;
  max-height: 200px;
  cursor: pointer;
  
  &:hover {
    background: ${({theme}) => `
      ${transparentize(.98, theme.colors.white)};
    `};
  }

  ${({isHidden}) => isHidden && css`
    ${Name} {
      color: ${({theme}) => `
        ${transparentize(.6, theme.colors.white)};
      `};
    }
  `};
`;

const AvatarBox = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

  width: 70px;
  height: 70px;
  min-width: 70px;
  min-height: 70px;

  border-radius: 50%;
  overflow: hidden;
`;

const Avatar = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const Name = styled.div`
  font-size: 15px;
  line-height: 19px;
  text-align: center;
  padding: 0 5px;
  white-space: pre-wrap;
`;

/**
 * The course student component
 * @param {StudentProps} props
 * @return {React.ReactElement}
 * @constructor
 */
export default function Student(
    props: StudentProps,
): React.ReactElement {
  const {name, avatar, isHidden} = props;

  /**
   * The function render student avatar
   * @return {React.ReactElement}
   */
  function renderAvatar() {
    const avatarComponent = isHidden
      ? <HiddenAvatar />
      : <Avatar src={avatar} alt="student avatar"/>;

    return (
      <AvatarBox>
        {avatarComponent}
      </AvatarBox>
    );
  }

  /**
   * The function render student name
   * @return {React.ReactElement}
   */
  function renderName() {
    const text = isHidden
      ? 'Студент\n скрыт'
      : name;

    return (
      <Name>
        {text}
      </Name>
    );
  }

  return (
    <Wrapper isHidden={isHidden}>
      {renderAvatar()}
      {renderName()}
    </Wrapper>
  );
}
